<!-- Header (company name) -->
<!-- <mat-toolbar color="white" class="toolbar">
    <h1>Acme Co</h1>
  </mat-toolbar> -->
  <div class="next-event-card">
    <mat-card appearance="outlined" class="event-card">
    @if(nextEvent && !nextEvent.date) {
      <mat-card-content>
        <p>{{dfsConstants.NO_EVENT_MESSAGE}}</p>
      </mat-card-content>
    } @else if (nextEvent && nextEvent.date) {
      <mat-card-content>
        <p>An upcoming event is scheduled at <em>{{nextEvent.date}}, {{nextEvent.time}}</em> where you can save up to <em>&pound;{{nextEvent.maxSavings}}</em></p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button (click)="openSavingsCalculator()">OPEN SAVINGS CALCULATOR</button>
        @if (nextEvent.status === eventStatus.OPTED_IN) {
          <button [disabled]="tpi" mat-button (click)="manageOpting(nextEvent, false)">OPT OUT</button>
        } @else {
          <button [disabled]="tpi" mat-button (click)="manageOpting(nextEvent, true)">OPT IN</button>
        }
      </mat-card-actions>
    }
    </mat-card>
  </div>


  <!-- Overview cards -->
  @if(lastEvent) {
    <div class="mb-3">
      Last event: <em>{{lastEvent.date}}, {{lastEvent.time}}</em>   <mat-chip class="event-status-chip">{{lastEvent.status}}</mat-chip>
    </div>
    <div class="overview-cards">
      <ng-container *ngTemplateOutlet="statTpl; 
        context: {title: 'Savings', value: lastEvent.savingsPercentage + '%', positive: lastEvent.savingsPercentage > 0}">
      </ng-container>
      <ng-container *ngTemplateOutlet="statTpl; 
        context: {title: 'Earnings', value: '&pound;' +lastEvent.earnings, positive: lastEvent.earnings > 0}">
      </ng-container>
      <ng-container *ngTemplateOutlet="statTplNtrl; 
        context: {title: 'Expected Usage', value: lastEvent.expectedUsage + 'kWh'}">
      </ng-container>
      <ng-container *ngTemplateOutlet="statTplNtrl; 
        context: {title: 'Actual Usage', value: lastEvent.actualUsage + 'kWh'}">
      </ng-container>
      @if (!tpi) {
        <ng-container *ngTemplateOutlet="statTplNtrl; 
          context: {title: 'Wallet', value: '&pound;' + walletBalance}">
        </ng-container>
      }
    </div>
  }

  <!-- Stats and charts -->
  <div class="stats-charts">
    <mat-card appearance="outlined" class="chart">
      <!-- <mat-card-header class="d-flex justify-content-between align-items-center">
        <mat-card-title>Wallet Summary</mat-card-title>
        <mat-card-subtitle>Balance: &pound;100</mat-card-subtitle>
        <mat-card-actions>
          <button mat-flat-button color="primary" aria-label="Withdraw">
            Withdraw
          </button>
        </mat-card-actions>
      </mat-card-header> -->
      <h3>Weekly forecast</h3>
       <mat-card-content>
      <!-- <app-wallet-summary></app-wallet-summary> -->
        <app-weekly-forecast></app-weekly-forecast>
       </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="top-products">
      <h3>Top Performers</h3>
      <mat-card-content>
        <app-leaderboard-chart [data]="topPerformers"></app-leaderboard-chart>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Recent Activity (table) -->
  <!-- <mat-card class="recent-activity">
    <h2>Recent Activity</h2>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let item">{{item.date}}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let item">
          <span [ngClass]="{'type-refund': item.type === 'Refund', 'type-order': item.type === 'Order'}">
            {{item.type}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let item">{{item.amount | currency}}</td>
      </ng-container>

      <ng-container matColumnDef="order">
        <th mat-header-cell *matHeaderCellDef>Order</th>
        <td mat-cell *matCellDef="let item">{{item.order}}</td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let item">{{item.customer}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </mat-card> -->

  <!-- Stats -->
  <ng-template #statTpl let-title="title" let-value="value" let-positive="positive">
    <mat-card class="card" appearance="outlined">
      <mat-card-header>
        <mat-card-subtitle>{{title}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content [ngClass]="{
        'stats-positive': positive,
        'stats-negative': !positive
      }">
      <div class="d-flex justify-content-between">
        <p>{{value}}</p>
        @if (positive) {
          <mat-icon>arrow_upward</mat-icon>
        } @else {
          <mat-icon>arrow_downward</mat-icon>
        }
      </div>
      </mat-card-content>
    </mat-card>
  </ng-template>

  <ng-template #statTplNtrl let-title="title" let-value="value">
    <mat-card class="card" appearance="outlined">
      <mat-card-header>
        <mat-card-subtitle>{{title}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>{{value}}</p>
      </mat-card-content>
    </mat-card>
  </ng-template>
